import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { Auth, Storage } from "aws-amplify";
import { Buffer } from "buffer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  convertJsonToXl,
  fetchJSONFromS3,
  invokeLambdaWithRetry,
  logAudit,
} from "services/Helper";
import { v4 as uuid } from "uuid";
import { useAppThemeContext } from "../ContextProvider";
import { isExistingTemplate } from "services/Helper";
import { createUiLogger } from "../../../logging/uiLogger";
import { navigateFromPlatform } from "../../../appNavigation";
const console = createUiLogger("meaplatform/newui/components/SaveChanges/index.jsx");



function SafeWrapper({ children }) {
  const navigate = useNavigate();
  let [assocCtryCodes, setAssocCtryCodes] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const {
    setconfirmTemplateSave,
    showConfirm,
    setShowConfirm,
    onConfirmCallback,
    tickedEntities,
    setTickedEntities,
    setLoading,
    showModal,
    setShowModal,
    showModalMsg,
    setShowModalMsg,
    listOfLobs,
    lobText,
    setLOBText,
    fetchTemplateList,
    storeWidgetName,
    storeTemplateName,
    storeSelectedRule,
    setStoreSelectedRule,
    storedNavigate,
    setStoredNavigate,
    activeStepName,
    setActiveStepName,
    templateName,
    fetchClientTemplates,
    setStoreTemplateName,
    rulesData,
    setRulesData,
    setTemplateName,
    templateCount,
    setTemplateCount,
    maxTemplateAllowedCount,
    setMaxTemplateAllowedCount,
    setTempStoreSelectedRule,
    setSelectedEntityDocPriorityList,
    selectedEntityDocPriorityList,
    setActiveStep,
  } = useAppThemeContext();

  const handleNavigateRoute = () => {
    setShowConfirm(false);
    if (storedNavigate && typeof storedNavigate === "object") {
      navigateFromPlatform(navigate, storedNavigate.url, {
        state: storedNavigate.state,
      });
    } else {
      navigate(storedNavigate);
    }
    setStoredNavigate(null);
    setconfirmTemplateSave(false);
    setTickedEntities([]);
    setStoreSelectedRule({});
    setLOBText("");
    setRulesData({});
    setActiveStepName("");
    setTempStoreSelectedRule({});
    setSelectedEntityDocPriorityList([]);
  };

  async function createLOBCode(lobCodeInput) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        access_token: user.signInUserSession.idToken.jwtToken,
        target: "createLOBCode",
        lobCodeInput: lobCodeInput,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function isCheck(
    templateName,
    templateFileName,
    templatePath,
    WidgetName,
    status,
    existingTemplate
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        target: "fetchTemplateList",
        access_token: user.signInUserSession.idToken.jwtToken,
        templateName: templateName,
        templateFileName: templateFileName,
        templatePath: templatePath,
        WidgetName: WidgetName,
        mode: "check",
        clientTemplate: true,
        checkOutputHeaders: "true",
        userId: user?.attributes?.email,
        newUi: true,
        Status: status,
        existingTemplate: existingTemplate,
      };

      if (selectedGroup !== "") {
        body.group_id = selectedGroup;
      }
      const init = {
        body: JSON.stringify(body),
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLight", init);
      if (data && data.statusCode !== 500 && data.statusCode !== 422) {
        setActiveStepName("");
        setTickedEntities([]);
        setStoreSelectedRule({});
        setLOBText("");
        setTemplateName("");
        setStoreTemplateName("");
        setconfirmTemplateSave(false);
        setRulesData({});
        setTempStoreSelectedRule({});
        setSelectedEntityDocPriorityList([]);
      }
      
      return data;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function createTemplate(
    xlFile,
    templateName,
    templateWidget,
    existingTemplate
  ) {
    try {
      let templatePath = `templates/${uuid()}${templateName}.xlsx`;
      let status = "InProgress";
      await Storage.put(templatePath, xlFile);

      var result = await isCheck(
        templateName,
        `${templateName}.xlsx`,
        templatePath,
        templateWidget,
        status,
        existingTemplate
      );
      
      if (result && result.statusCode === 422) {
        setShowModal(true);
        setShowModalMsg(result.errorMsg);
        return result;
      }
      
      if (result && result.statusCode === 500) {
        console.error("Server error while creating template:", result);
        return result;
      }
      
      if (!result) {
        console.error("Failed to create template - no result returned");
        return false;
      }
      
      logAudit(
        undefined,
        undefined,
        "Template",
        "Created",
        "UI",
        templateName,
        templatePath
      );
      
      return result;
    } catch (err) {
      console.error("Error in createTemplate:", err);
      return false;
    }
  }

  async function addLOBCode() {
    const lobCodeInput = {
      LOBCode: lobText,
      LineOfBusiness: lobText,
      AssocCountryCodes: assocCtryCodes.join(","),
      CreateType: "client",
    };
    await createLOBCode(lobCodeInput);
    logAudit(
      undefined,
      undefined,
      "LOB",
      "Created",
      "UI",
      lobText,
      lobText
    ).then((data) => {});
    setLOBText("");
  }

  const toTitleCaseWithSpaces = (camelCaseKey) => {
    return camelCaseKey
      .replace(/([A-Z])/g, " $1") // insert space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
  };

  async function isCheckAndStoreRegions(
    templateName,
    templatePath,
    existingTemplate
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      let status = "InProgress";
      const body = {
        target: "fetchTemplateList",
        access_token: user.signInUserSession.idToken.jwtToken,
        templateName: templateName,
        templateFileName: `${templateName}.xlsx`,
        mode: "check",
        userId: user?.attributes?.email,
        Status: status,
        templatePath: templatePath,
        checkOutputHeaders: "true",
        newUi: true,
        existingTemplate: existingTemplate,
      };
      const init = {
        body: JSON.stringify(body),
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLight", init);
      if (data && data.statusCode !== 500 && data.statusCode !== 422) {
        setActiveStepName("");
        setTickedEntities([]);
        setStoreSelectedRule({});
        setLOBText("");
        setTemplateName("");
        setStoreTemplateName("");
        setconfirmTemplateSave(false);
        setShowConfirm(false);
        setRulesData({});
        setTempStoreSelectedRule({});
        setSelectedEntityDocPriorityList([]);
        setActiveStep(0);
        await fetchTemplateList();
      }
      
      return data;
    } catch (err) {
      console.error("err: ", err);
      return false;
    }
  }

  function convertToMacroRules(data) {
    const rulesDataMap = new Map(
      (Array.isArray(rulesData) ? rulesData : []).map((item) => [item.entityName, item])
    );

    const savedDocPriorityMap = new Map(
      (Array.isArray(selectedEntityDocPriorityList) ? selectedEntityDocPriorityList : [])
        .map((item) => [item.entityName, item.documentPrioritization])
    );

    const result = {
      macroRules: Object.entries(data).map(([entityName, rules]) => {
        const meta = rulesDataMap.get(entityName) || {};
        const docPriority = savedDocPriorityMap.has(entityName)
          ? savedDocPriorityMap.get(entityName)
          : [];
        return {
          aiFieldName: meta.aiFieldName ?? null,
          entityName,
          documentPrioritization: docPriority,
          synonyms: meta.synonyms ?? [],
          expected_locations: meta.expected_locations ?? {},
          rules,
          relationships: meta.relationships ?? {},
          ambiguity_handling: meta.ambiguity_handling ?? {},
          inference_notes: meta.inference_notes ?? {},
        };
      }),
    };
    return result;
  }

  function splitTemplateRuleFiles(templateRulesConfig = {}) {
    const entities = Array.isArray(templateRulesConfig?.entities)
      ? templateRulesConfig.entities
      : Array.isArray(templateRulesConfig?.macroRules)
      ? templateRulesConfig.macroRules
      : [];

    const {
      entities: _entities,
      macroRules: _macroRules,
      ...sharedTemplateConfig
    } = templateRulesConfig || {};

    return {
      rulesPayload: {
        ...sharedTemplateConfig,
        macroRules: [],
      },
      uiRulesPayload: {
        entities,
      },
    };
  }

  function selectTemplateConfigBase(...configs) {
    return (
      configs.find(
        (config) =>
          config &&
          typeof config === "object" &&
          Object.keys(config).some(
            (key) => key !== "macroRules" && key !== "entities"
          )
      ) ||
      configs.find((config) => config && typeof config === "object") ||
      {}
    );
  }

  function buildTemplateRuleFiles(data, templateConfig = {}) {
    const rulesPayload = convertToMacroRules(data);
    return splitTemplateRuleFiles({
      ...templateConfig,
      entities: Array.isArray(rulesPayload?.macroRules) ? rulesPayload.macroRules : [],
    });
  }

  async function storeTemplateRules(templateName, templateRules) {
    let templateRulesJson = `templates/rules/${templateName}_rules.json`;
    let templateUiRulesJson = `templates/rules/${templateName}_ui_rules.json`;
    const existingRulesConfig = await fetchJSONFromS3(templateRulesJson);
    const existingUiRulesConfig = await fetchJSONFromS3(templateUiRulesJson);
    const templateConfig = selectTemplateConfigBase(
      existingRulesConfig,
      existingUiRulesConfig
    );
    const { rulesPayload, uiRulesPayload } = buildTemplateRuleFiles(
      templateRules,
      templateConfig
    );
    await Storage.put(
      templateRulesJson,
      Buffer.from(JSON.stringify(rulesPayload), "utf8")
    );
    await Storage.put(
      templateUiRulesJson,
      Buffer.from(JSON.stringify(uiRulesPayload), "utf8")
    );
  }

  const handleSaveAndContinue = async () => {
    setLoading(true);
    setShowConfirm(false);
    try {
      const templatesAllCount = await fetchTemplateListCount(true);
      if (templatesAllCount === false) {
        setShowModalMsg(
          `You have exceeded Max templates allowed count. Please contact Support team`
        );
        setShowModal(true);
        setLoading(false);
        return;
      }

      var existingTemplate = await isExistingTemplate(
        storeTemplateName || `${lobText}-${templateName}`
      );

      const savedDocPrioritySet = new Set(
        (Array.isArray(selectedEntityDocPriorityList) ? selectedEntityDocPriorityList : [])
          .filter(item => item.documentPrioritization?.length > 0)
          .map(item => item.entityName)
      );

      const transformedData = tickedEntities.map((item) => {
        const newItem = {};
        Object.keys(item).forEach((key) => {
          let newKey = toTitleCaseWithSpaces(key);

          // Special case
          if (newKey === "Example Description") {
            newKey = "Example/Description";
          }

          if (newKey === "Data Type" && Array.isArray(item[key])) {
            newItem[newKey] = item[key][0] ?? "";
          }
          else if (newKey === "Document Prioritization" && Array.isArray(item[key])) {
            if (savedDocPrioritySet.has(item.entityName)) {
              newItem[newKey] = item[key].join(", ");
            } else {
              newItem[newKey] = ""; 
            }
          } else {
            newItem[newKey] = item[key];
          }
        });
        return newItem;
      });

      if (!listOfLobs.some((lob) => lob.LOBCode == lobText)) {
        await addLOBCode();
      }

      const transformedActiveData = [
        ...transformedData,
        { activeStep: activeStepName },
      ];

      let saveResult;
      // newly creating templates to save as inprogress
      if (!existingTemplate) {
        const xlFile = await convertJsonToXl(transformedActiveData);
        await storeTemplateRules(storeTemplateName, storeSelectedRule);
        saveResult = await createTemplate(
          xlFile,
          storeTemplateName,
          storeWidgetName,
          existingTemplate
        );
        
        if (saveResult === false || (saveResult && saveResult.statusCode === 500)) {
          setShowModalMsg("Failed to save template. Please try again.");
          setShowModal(true);
          setLoading(false);
          return;
        }
        
        await fetchTemplateList();
      }
      // existing template to save as updated values with inprogress status
      else {
        const filterTemplateDetails = fetchClientTemplates.find(
          (item) => item.TemplateName === storeTemplateName
        );

        let templateExcelPath = filterTemplateDetails?.TemplatePath;
        let existTemplateName = filterTemplateDetails?.TemplateName;
        const xlFile = await convertJsonToXl(transformedActiveData);
        await Storage.put(templateExcelPath, xlFile);
        await storeTemplateRules(storeTemplateName, storeSelectedRule);
        saveResult = await isCheckAndStoreRegions(
          existTemplateName,
          templateExcelPath,
          existingTemplate
        );
        
        if (saveResult === false || (saveResult && saveResult.statusCode === 500)) {
          setShowModalMsg("Failed to update template. Please try again.");
          setShowModal(true);
          setLoading(false);
          return;
        }
      }

      navigate("/user/template-view", {
        state: { template: "newTemplate" },
      });
      
      if (onConfirmCallback) onConfirmCallback();
    } catch (error) {
      setLoading(false);
      console.error("Error in handleSaveAndContinue:", error);
      setShowModalMsg("An error occurred while saving. Please try again.");
      setShowModal(true);
    }
  };

  async function fetchTemplateListCount(enableCount) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        target: "fetchTemplateList",
        access_token: user.signInUserSession.idToken.jwtToken,
        count: templateCount,
        rowStart: 0,
        pageSize: 2,
        searchTemplateName: "",
        mode: "like",
      };
      const init = {
        body: JSON.stringify(body),
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLight", init);
      if (templateCount === -1) {
        setTemplateCount(data.count);
      }
      if (enableCount === true && data.count >= maxTemplateAllowedCount) {
        return false;
      } else {
        return data.templates;
      }
    } catch (err) {
      console.error("err: ", err);
      return false;
    }
  }

  return (
    <>
      {children}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="submissions-headermodal"
        open={showConfirm}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={showConfirm}>
          <Box className="modal-layout d-flex-content-center">
            <Box className="modal-bglayer businessmodal-bglayer p-4">
              <h2 className="flex-colcenter">Unsaved data</h2>
              <p className="flex-colcenter">
                Would you like to save the changes?
              </p>

              <Box className="d-flex-content-center gap-2 mt-4">
                <button
                  className="modal-button business-button-modal save-modal-button"
                  onClick={() => setShowConfirm(false)}
                >
                  Stay
                </button>

                <button
                  className="modal-button business-button-modal save-modal-button"
                  onClick={() => handleNavigateRoute()}
                >
                  No, thanks
                </button>

                <button
                  className="modal-button business-button-modal save-modal-button"
                  onClick={() => {
                    handleSaveAndContinue();
                  }}
                >
                  Save
                </button>
              </Box>

              <Box className="modal-footer-new d-flex-content-center mt-4">
                <Box className="modal-footerTitle">
                  Powered by <span className="fw-600">mea platform</span>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default SafeWrapper;
